import React from "react";
import styled from "styled-components";
import Banner from "../components/homeComponents/Banner";
import HeroScrollEffect from "../components/homeComponents/HeroScrollEffect";
import DomeGallery from "../components/homeComponents/DomeGallery";
import WeDoParallax from "../components/homeComponents/WeDoParallax";
import WebsiteShowcase from "../components/homeComponents/WebsiteShowcase";
import ScrollFloat from "../components/homeComponents/ScrollFloat";
import VelocityMarquee from "../components/homeComponents/VelocityMarquee";
import CaseStudies from "../components/homeComponents/CaseStudies";
import ProcessReel from "../components/homeComponents/ProcessReel";
import Manifesto from "../components/homeComponents/Manifesto";
import FinalCTA from "../components/homeComponents/FinalCTA";
import FeedTest from "../components/homeComponents/FeedTest";
import ConversionMachine from "../components/homeComponents/ConversionMachine";
import FAQ from "../components/homeComponents/FAQ";
import ContactUs from "../components/homeComponents/ContactUs";
import Temp from "../components/homeComponents/Temp";

const Home = () => {
  return (
    <Container>
      <Banner />
      <HeroScrollEffect />
      <WeDoParallax />

      {/* <VelocityMarquee /> */}
      <CaseStudies />
      <ConversionMachine />

      <ScrollFloat
        animationDuration={2}
        ease="back.inOut(2)"
        scrollStart="center bottom+=50%"
        scrollEnd="bottom bottom-=80%"
        stagger={0.03}
      >
        A World of Post Designs
      </ScrollFloat>
      <div style={{ width: "100vw", height: "100vh" }}>
        <DomeGallery />
      </div>
      {/* <div style={{ marginTop: "40em" }}>
        <ScrollFloat
          animationDuration={2}
          ease="back.inOut(2)"
          scrollStart="center bottom+=50%"
          scrollEnd="bottom bottom-=110%"
          stagger={0.03}
        >
          Now some Websites
        </ScrollFloat>
      </div>
      <WebsiteShowcase /> */}

      <FeedTest />

      <FAQ />
      <ContactUs />
      <Temp />
    </Container>
  );
};
const Container = styled.div`
  padding: 0%;
`;

export default Home;
